import { ShapeProps, Slide } from '@features/powerpoint';
import { ImageWithMetadata } from '@features/powerpoint';
import {
  texts,
  CampaignOverviewTextsOptions,
  DIMENSION_TEXT_OFFSET,
} from './campaign-overview/texts';
import { buildCampaignOverviewSlide } from '@features/executive-report/slides/campaign-overview';
import { theme } from '@features/executive-report/domain/theme';

export type RslCampaignOverviewSlideOptions = Omit<
  CampaignOverviewTextsOptions,
  'dimensionCounts'
> & {
  brandLogoWithMetadata: ImageWithMetadata | null;
  dimensionCounts: [number, number, number];
};

const buildDimensionShapes = (index: number): ShapeProps[] => [
  {
    shapeName: 'rect',
    options: {
      fill: {
        color: theme.colors.darkGray,
      },
      line: {
        color: theme.colors.inmarketGreen,
        width: 1,
      },
      h: 3.24,
      w: 2.71,
      x: 4.31 + index * DIMENSION_TEXT_OFFSET,
      y: 2.05,
    },
  },
  {
    shapeName: 'line',
    options: {
      line: {
        color: theme.colors.white,
        width: 1,
      },
      h: 0,
      w: 2.28,
      x: 4.52 + index * DIMENSION_TEXT_OFFSET,
      y: 3.26,
    },
  },
  {
    shapeName: 'rect',
    options: {
      fill: {
        color: theme.colors.inmarketGreen,
        transparency: 86,
      },
      h: 1.34,
      w: 2.28,
      x: 4.52 + index * DIMENSION_TEXT_OFFSET,
      y: 3.69,
    },
  },
];

export const rslCampaignOverviewSlide = (
  options: RslCampaignOverviewSlideOptions
): Slide => {
  const dimensionShapes: ShapeProps[] = [0, 1, 2].flatMap(index =>
    buildDimensionShapes(index)
  );

  return buildCampaignOverviewSlide(
    texts({ ...options, dimensionCounts: options.dimensionCounts }),
    dimensionShapes,
    options.brandLogoWithMetadata,
    { x: 0.88, y: 2.05 }
  );
};
